import PropTypes from 'prop-types'
import { Icon } from '@iconify/react'
import pinFill from '@iconify/icons-eva/pin-fill'
import emailFill from '@iconify/icons-eva/email-fill'
import roundBusinessCenter from '@iconify/icons-ic/round-business-center'
// material
import { experimentalStyled as styled } from '@material-ui/core/styles'
import { Link, Card, Typography, CardHeader, Stack } from '@material-ui/core'
import { UploadAvatar } from 'src/components/upload'
import { useCallback, useState } from 'react'
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage'
import { storage } from 'src/firebase/firebase'
import Label from 'src/components/Label'
import axios from 'axios'
import { REST_API_END_POINT } from 'src/constants/Defaultvalues'
import { useSnackbar } from 'notistack'
import { supabase } from '../../../../supabase/supabaseClient';

// ----------------------------------------------------------------------
const LabelStyle = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle2,
  color: theme.palette.text.secondary,
  textAlign:'center',
  marginBottom: theme.spacing(1)
}));
const IconStyle = styled(Icon)(({ theme }) => ({
  width: 20,
  height: 20,
  marginTop: 1,
  flexShrink: 0,
  marginRight: theme.spacing(2),
}))

// ----------------------------------------------------------------------

ProfileAbout.propTypes = {
  profile: PropTypes.object,
  userData: PropTypes.object,
  teamData: PropTypes.object,
}

export default function ProfileAbout({ profile, userData, teamData,internalNotes,setCoverImage,coverImage }) {
  const { quote, country, email, role, company, school } = profile
  const {enqueueSnackbar}=useSnackbar()

  const updateCoverImage=async(imgURL)=>{
    let response;
    if(teamData){
      response = await axios.post(`${REST_API_END_POINT}teams/update-cover-image`,{
        userId:userData.user_id,imgURL:imgURL
      })
    }
    else{
      response = await axios.post(`${REST_API_END_POINT}clients/update-coverimage`,{
        userid:userData.user_id,imgURL:imgURL
      })
    }
    if(response.data.status ==1){
      enqueueSnackbar(response.data.message,{variant:'success'})
    }else{
      enqueueSnackbar(response.data.message,{variant:'error'})
    }
  
  }
  // const handleDrop = useCallback(
  //   (acceptedFiles) => {
  //     if (acceptedFiles && acceptedFiles.length > 0) {
  //       const file = acceptedFiles[0]; 
  //       const Filename = new Date().getTime() + file.name;
  
  //       const StorageRef = ref(storage, Filename);
  //       const uploadTask = uploadBytesResumable(StorageRef, file);
  
  //       uploadTask.on(
  //         'state_changed',
  //         (snapshot) => {
  //           const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);

  //         },
  //         (error) => {
  //           console.error(error.message);
  //         },
  //         () => {
  //           getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {              
  //             setCoverImage(downloadURL)
  //               updateCoverImage(downloadURL)
  //             console.log(downloadURL, '&&&&&&&&&&&&&&&&&&&');
  //           });
  //         }
  //       );
  //     } 
      
  //   },
  //   [setCoverImage]
  // );
  
  const handleDrop = useCallback(
    async (acceptedFiles) => {
      if (!acceptedFiles?.length) return;

      const file = acceptedFiles[0];
      const ts = Date.now();
      const cleanName = file.name.replace(/\s+/g, '_');
      const filePath = `client-images/cover-images/${ts}_${cleanName}`;   // ✅ new path

      try {
        /* ---------- upload ---------- */
        const { error: upErr } = await supabase.storage
          .from('signwise-attachments')
          .upload(filePath, file);

        if (upErr) throw upErr;

        /* ---------- public URL ------ */
        const { data, error: urlErr } = supabase.storage
          .from('signwise-attachments')
          .getPublicUrl(filePath);

        if (urlErr || !data?.publicUrl) throw urlErr || new Error('URL error');

        /* ---------- update UI ------- */
        setCoverImage(data.publicUrl);
        updateCoverImage?.(data.publicUrl);   // call if it exists
        console.log('Uploaded cover:', data.publicUrl);
      } catch (err) {
        console.error('Upload failed:', err.message);
      }
    },
    [setCoverImage, updateCoverImage]
  );

return (
    <Stack spacing={2}>
      {(teamData.internal_note || internalNotes) ? (
        <Card sx={{ width: '100%' }}>
          <CardHeader title="Internal Note" />
          <Stack spacing={2} sx={{ p: 3 }}>
            <Typography variant="body2" sx={{ mb: 3 }}>
              {teamData.internal_note ? teamData.internal_note : internalNotes}
            </Typography>
          </Stack>
        </Card>
      ) : null }

      <Card sx={{ width: '100%' }}>
        <Stack spacing={2} sx={{ p: 3 }}>
          {(teamData.city || teamData.state) && (
            <Stack direction="row">
              <IconStyle icon={pinFill} />
              <Typography variant="body2">
                Live at &nbsp;
                <Link component="span" variant="subtitle2" color="text.primary">
                  {(teamData.city ? `${teamData.city}` : '') +
                    (teamData.city && teamData.state ? ', ' : '') +
                    (teamData.state ? `${teamData.state}` : '')}
                </Link>
              </Typography>
            </Stack>
          )}

          <Stack direction="row">
            <IconStyle icon={emailFill} />
            <Typography variant="body2">{userData.email}</Typography>
          </Stack>

          <Stack direction="row">
            <IconStyle icon={roundBusinessCenter} />
            <Typography variant="body2">
              {userData.isVendor===1 ? 'Vendor' : userData?.user_type == 3 ? 'Client' : userData.user_role} at &nbsp;
              <Link component="span" variant="subtitle2" color="text.primary">
                {userData.company_name}
              </Link>
            </Typography>
          </Stack>
        </Stack>
        {(userData?.user_type ==3 || teamData) &&
        <>
        <UploadAvatar sx={{mb:1}}        
         accept="image/*"
         file={coverImage}
         maxSize={1024 * 1024 * 1024}
         type="file"
         onDrop={handleDrop}
        />
        <LabelStyle>Update Cover Image</LabelStyle>
        </>
        }
      </Card>
    </Stack>
  )
}
